/**
 * Checks if a given element is fully within the viewport.
 *
 * @param element - The DOM element to check.
 * @returns A boolean indicating whether the element is fully in the viewport.
 */
export function isElementFullyInViewport(element: Element): boolean {
  const rect = element.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

/**
 * Scrolls to the given element if it is not fully visible in the viewport.
 *
 * @param element - The DOM element to check.
 */
export const scrollToElementIfNotInView = (element: Element | null | undefined): void => {
  if (
    element &&
    typeof element.scrollIntoView === "function" &&
    typeof element.getBoundingClientRect === "function"
  ) {
    if (!isElementFullyInViewport(element)) {
      element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  }
};

/**
 * Scrolls the page smoothly to the html element, or to another selector if provided.
 *
 * @param {string} [positionSelector="html"] - The CSS selector of the element to scroll to.
 */
export function scrollToApp(positionSelector: string = "html") {
  const element = window.document.querySelector(positionSelector);

  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
}
